import React from "react";
import Text from "./Text.react";

export default class Question extends React.Component {
    render() {
        // let isPortrait =
        //     this.props.mobileView || window.innerHeight > window.innerWidth;
        let componentStyles = {
            default: {
                background: `${this.props.colors.base}cc`,
                padding: "10px",
                fontSize: "1.25em",
                fontWeight: "bold",
            },
            grid: {},
        };

        return (
            <div
                style={
                    this.props.data.question
                        ? componentStyles[this.props.layout]
                        : {}
                }
            >
                <Text
                    keyName={"question-" + this.props.slideId}
                    text={this.props.data.question}
                    color={this.props.colors.baseText}
                    fontSize="large"
                    animation="fadeIn,100"
                />
            </div>
        );
    }
}
